import { InjectionToken } from '@angular/core';
import {
  ContentAlignmentEnum,
  EntityListField,
  PERMISSION_ACCESS,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@ideapa/app-common';
import { FieldType, FilterType } from '@ideapa/common-interfaces';

export const ENTITY = 'controllo-saldi';
export const ENTITY_PLURAL = 'Controllo saldi';
export const gridColumns: EntityListField[] = [
  {
    elementLabel: 'Tipo conto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.tipo',
  },
  {
    elementLabel: 'Codice conto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.codice',
  },
  {
    elementLabel: 'Descrizione conto',
    filterType: FilterType.text,
    fieldType: FieldType.text,
    field: 'pianoConti.descrizione',
    sortable: true,
  },
  {
    elementLabel: 'Saldo Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoDare',
    sortable: true,
  },
  {
    elementLabel: 'Movimenti Dare',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'totaleMovimentiDare',
    sortable: true,
  },
  {
    elementLabel: 'saldo Avere',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldoAvere',
    sortable: true,
  },
  {
    elementLabel: 'Movimenti Avere',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'totaleMovimentiAvere',
    sortable: true,
  },
  {
    elementLabel: 'Saldo al 31/12',
    filterType: FilterType.number,
    fieldType: FieldType.currency,
    contentAlignment: ContentAlignmentEnum.Right,
    field: 'saldo31_12',
    sortable: true,
  },
];
export const PERMISSION_ACCESS_ENTITY = `${PERMISSION_ACCESS}_${ENTITY}`;
export const PERMISSION_CREATE_ENTITY = `${PERMISSION_CREATE}_${ENTITY}`;
export const PERMISSION_READ_ENTITY = `${PERMISSION_READ}_${ENTITY}`;
export const PERMISSION_UPDATE_ENTITY = `${PERMISSION_UPDATE}_${ENTITY}`;
export const PERMISSION_DELETE_ENTITY = `${PERMISSION_DELETE}_${ENTITY}`;

export const SHARED_ENTITY_ACTIONS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_ACTIONS'
);

export const SHARED_ENTITY_SELECTORS_TOKEN = new InjectionToken<string>(
  'SHARED_ENTITY_SELECTORS'
);

export const ENTITY_NAME_TOKEN = new InjectionToken<string>('ENTITY_NAME');
